import { useEffect } from 'react';

export const useBranchSelect = ({
    selectedBranchId,
    selectedDoctorId,
    setServicesList,
    setSelectedServiceId,
    allDoctors,
    allServices,
    selectedServiceId,
    selectedInfo,
}) => {
    useEffect(() => {
        if (selectedBranchId) {
            const filteredDoctors = allDoctors.filter(doctor => doctor.worksAt?.some(({ branchId }) => branchId === selectedBranchId));

            const filteredServices = allServices.filter(service => filteredDoctors.some(doctor => (!selectedDoctorId || doctor.doctorId === selectedDoctorId) &&
                    doctor.worksAt?.some(({ branchId, serviceMappings }) => branchId === selectedBranchId &&
                        serviceMappings?.some(({ serviceId }) => serviceId === service.id))));

            setServicesList(filteredServices);

            const shouldPreselect = !selectedServiceId || !filteredServices.some(s => s.id === selectedServiceId);
            if (shouldPreselect) {
                if (filteredServices.length === 1) {
                    setSelectedServiceId(filteredServices[0].id);
                } else if (selectedDoctorId) {
                    const doctor = filteredDoctors.find(d => d.doctorId === selectedDoctorId);
                    const branchWorksAt = doctor?.worksAt?.find(w => w.branchId === selectedBranchId);
                    const defaultServiceId = branchWorksAt?.serviceMappings?.find(sm => sm.defaultService)?.serviceId;
                    if (defaultServiceId) {
                        const defaultService = filteredServices.find(s => s.id === defaultServiceId);
                        if (defaultService) {
                            setSelectedServiceId(defaultService.id);
                            return;
                        }
                    }
                    if (selectedServiceId && !filteredServices.some(s => s.id === selectedServiceId)) {
                        setSelectedServiceId('');
                    }
                }
            }
        } else if (!selectedInfo?.branches) {
            setServicesList([]);
            setSelectedServiceId('');
        }
    }, [ selectedBranchId, allDoctors?.length, allServices?.length ]);
};
